import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles } from 'lucide-react';
const slides = [{
  id: 1,
  image: 'https://cdn.magicpatterns.com/uploads/bGArQjptwt2EVfcjJTevVq/c1.png',
  alt: 'Historias Magnéticas',
  label: 'Libro Principal'
}, {
  id: 2,
  image: 'https://cdn.magicpatterns.com/uploads/bDfc2Mh82Yer21dnGmyfwP/c2.png',
  alt: 'Máster de la Voz',
  label: 'Bono Exclusivo #1'
}, {
  id: 3,
  image: 'https://cdn.magicpatterns.com/uploads/rUhvXKuMFhhkzPHQfDycxN/c3.png',
  alt: 'Lenguaje Corporal',
  label: 'Bono Exclusivo #2'
}, {
  id: 4,
  image: 'https://cdn.magicpatterns.com/uploads/ify7WAJMZFiEkSgC9xqHiN/c4.png',
  alt: 'Tu Aura Digital',
  label: 'Bono Exclusivo #3'
}, {
  id: 5,
  image: 'https://cdn.magicpatterns.com/uploads/rLKhfbfZNxiRj5EmQ13taR/c5.png',
  alt: 'Comunicación Magnética',
  label: 'Bono Exclusivo #4'
}, {
  id: 6,
  image: 'https://cdn.magicpatterns.com/uploads/azTF6gQHpGnwnipMeuRcXX/c6.png',
  alt: 'Domina el Escenario',
  label: 'Bono Exclusivo #5'
}, {
  id: 7,
  image: 'https://cdn.magicpatterns.com/uploads/wNwb1hgFHiSATY9HGHkKTy/c7.png',
  alt: 'Arma tu Home Studio Pro',
  label: 'Bono Exclusivo #6'
}];
export function MobileBonusCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % slides.length);
    }, 3500);
    return () => clearInterval(interval);
  }, [isPaused]);
  const handleDragEnd = (event: any, info: any) => {
    if (info.offset.x < -50) {
      setCurrentIndex(prev => (prev + 1) % slides.length);
    } else if (info.offset.x > 50) {
      setCurrentIndex(prev => (prev - 1 + slides.length) % slides.length);
    }
  };
  return <section className="md:hidden w-full bg-[#050505] py-12 relative overflow-hidden border-t border-[#C9A961]/20" data-id="element-223">
      {/* Cinematic Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#C9A961]/10 via-transparent to-transparent opacity-30 pointer-events-none" data-id="element-224" />

      {/* Header */}
      <div className="text-center mb-8 relative z-10 px-4" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex items-center justify-center gap-2 mb-2" data-id="element-226">
          <Sparkles className="w-3 h-3 text-[#C9A961]" data-id="element-227" />
          <span className="text-[#C9A961] text-[10px] font-bold tracking-[0.2em] uppercase" data-id="element-228">
            Colección Premium
          </span>
          <Sparkles className="w-3 h-3 text-[#C9A961]" data-id="element-229" />
        </motion.div>
        <h2 className="text-xl font-light text-white tracking-wide" data-id="element-230">
          Pack{' '}
          <span className="text-[#C9A961] font-serif italic" data-id="element-231">Completo</span>
        </h2>
      </div>

      {/* Carousel Container */}
      <div className="relative w-full max-w-[320px] mx-auto h-[450px] perspective-1000" onTouchStart={() => setIsPaused(true)} onTouchEnd={() => setIsPaused(false)} data-id="element-232">
        <AnimatePresence mode="wait" data-id="element-233">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          scale: 0.9,
          rotateY: 10
        }} animate={{
          opacity: 1,
          scale: 1,
          rotateY: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          rotateY: -10
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} drag="x" dragConstraints={{
          left: 0,
          right: 0
        }} dragElastic={0.2} onDragEnd={handleDragEnd} className="absolute inset-0 flex items-center justify-center px-4" data-id="element-234">
            {/* Card Frame */}
            <div className="relative w-full h-full rounded-xl overflow-hidden shadow-[0_0_30px_rgba(201,169,97,0.15)] group" data-id="element-235">
              {/* Golden Border Gradient */}
              <div className="absolute inset-0 p-[1px] bg-gradient-to-b from-[#C9A961]/50 via-[#C9A961]/10 to-[#C9A961]/30 rounded-xl z-20 pointer-events-none" data-id="element-236" />

              {/* Image Container */}
              <div className="relative w-full h-full bg-[#0a0a0a] rounded-xl overflow-hidden" data-id="element-237">
                <img src={slides[currentIndex].image} alt={slides[currentIndex].alt} className="w-full h-full object-cover" data-id="element-238" />

                {/* Premium Shine Effect */}
                <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent -translate-x-full animate-[shine_3s_infinite] pointer-events-none" data-id="element-239" />

                {/* Bottom Gradient Overlay */}
                <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-black/90 to-transparent z-10" data-id="element-240" />

                {/* Label */}
                <div className="absolute top-4 right-4 z-20" data-id="element-241">
                  <div className="px-3 py-1 bg-black/60 backdrop-blur-md border border-[#C9A961]/30 rounded-full" data-id="element-242">
                    <span className="text-[#C9A961] text-[10px] font-medium tracking-wider uppercase" data-id="element-243">
                      {slides[currentIndex].label}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>

        {/* Navigation Dots */}
        <div className="absolute -bottom-8 left-0 right-0 flex justify-center gap-3 z-30" data-id="element-244">
          {slides.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`h-1.5 rounded-full transition-all duration-500 ${idx === currentIndex ? 'w-8 bg-[#C9A961] shadow-[0_0_10px_#C9A961]' : 'w-1.5 bg-[#C9A961]/20'}`} aria-label={`Go to slide ${idx + 1}`} data-id="element-245" />)}
        </div>
      </div>
    </section>;
}